import { render, staticRenderFns } from "./ReportPayableReceivable.vue?vue&type=template&id=195df09f&"
import script from "./ReportPayableReceivable.vue?vue&type=script&lang=js&"
export * from "./ReportPayableReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports